// The section a screen's title and arrival announcement name: the active tab of the screen's own tabs. Window-free,
// so the shell suite loads it without the router.

/** The active tab: V1's plain tab links and the design system's route tabs. */
export const ACTIVE_TAB = 'main nav.tabs [aria-current="page"], main nav.mc-tabs [aria-current="page"]';

/**
 * The active tab's name. A design-system route tab holds its name in .mc-tab-t and its count or pill beside it, which
 * are not part of the name ("Prioritized actions", never "Prioritized actions1"); a V1 tab link is its own text.
 */
export function sectionWords(root: ParentNode): string | undefined {
  const tab = root.querySelector<HTMLElement>(ACTIVE_TAB);
  if (!tab) return undefined;
  return (tab.querySelector<HTMLElement>(".mc-tab-t") ?? tab).textContent?.trim();
}
